import * as succeedFastTechRole from './succeedFastTechRole.js';
import * as stayProductiveMaintainWorkLifeBalance from './stayProductiveMaintainWorkLifeBalance.js';
import * as whatILearnedUsingGithubCopilot from './whatILearnedUsingGithubCopilot.js';
import * as promptEngineering from './promptEngineering.js';
import * as promptEngineeringMakeYourAskSimple from './promptEngineeringMakeYourAskSimple.js';
import * as howToPrepareForMeetings from './howToPrepareForMeetings.js';
import * as whyTakingVacationIsImportant from './whyTakingVacationIsImportant.js';
import * as installGithubCopilotCli from './installGithubCopilotCli.js';

export const blogIndex = [
    {
        id: "installGithubCopilotCli",
        title: "How to install GitHub Copilot in the CLI?",
        excerpt: "I have been using GitHub Copilot Chat, but I recently started using it in my CLI. Here is how to install it.",
        date: "October 25, 2026"
    },
    {
        id: "whyTakingVacationIsImportant",
        title: "Why is taking a vacation important?",
        excerpt: "A short reflection on why taking vacations matters for professionals: rest, reconnection, and returning to work energized and productive.",
        date: "August 23, 2026"
    },
    {
        id: "howToPrepareForMeetings",
        title: "How to prepare for meetings in corporate tech",
        excerpt: "Meetings are a big part of working in corporate tech. Here are the tips that personally work for me when it comes to showing up prepared and making the most of every meeting.",
        date: "May 26, 2026"
    },
    {
        id: "promptEngineeringMakeYourAskSimple",
        title: "Prompt engineering best practices: make your ask simple and give an example or two",
        excerpt: "One prompt, one goal. Learn why keeping your ask simple and backing it up with examples leads to better AI responses — with two practical examples to show the difference.",
        date: "May 1, 2026"
    },
    {
        id: "promptEngineering",
        title: "Prompt engineering best practices: what I learned about starting with a high-level goal",
        excerpt: "Something I have learned about lately is prompt engineering. I decided to dig in more and share what I found, including the dos and don'ts and how to start with a high-level goal.",
        date: "March 22, 2026"
    },
    {
        id: "whatILearnedUsingGithubCopilot",
        title: "What I have learned by using GitHub Copilot",
        excerpt: "I started using GitHub Copilot and never looked back. Here are some of the things I learned and the features I enjoy using the most.",
        date: "March 4, 2026"
    },
    {
        id: "stayProductiveMaintainWorkLifeBalance",
        title: "How to stay productive and maintain work-life balance in tech",
        excerpt: "Today I want to share some reflections on productivity and work-life balance that have been working for me in my tech career. These are practical strategies I've developed while working in corporate Sweden.",
        date: "February 7, 2026"
    },
    {
        id: "succeedFastTechRole",
        title: "How to succeed fast in your new tech role",
        excerpt: "Why I think by doing the following things - you will succeed fast in your new tech role",
        date: "January 18, 2026"
    }
];

export const postMap = {
    "howToPrepareForMeetings": howToPrepareForMeetings.post,
    "promptEngineering": promptEngineering.post,
    "promptEngineeringMakeYourAskSimple": promptEngineeringMakeYourAskSimple.post,
    "succeedFastTechRole": succeedFastTechRole.post,
    "stayProductiveMaintainWorkLifeBalance": stayProductiveMaintainWorkLifeBalance.post,
    "whatILearnedUsingGithubCopilot": whatILearnedUsingGithubCopilot.post,
    "whyTakingVacationIsImportant": whyTakingVacationIsImportant.post,
    "installGithubCopilotCli": installGithubCopilotCli.post
};
